import { useMemo } from "react";
import { Box } from "@mui/material";
import Alert from "@mui/material/Alert";
import { GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { SETTLEMENTS_ENDPOINT } from "../../../consts";
import { formatNumber, getMonthNames } from "../../../utils";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { useHasPermission } from "../../../contexts/auth";

export const SettlementsStatistics = () => {
  const { t } = useTranslation();
  const canViewSaleSummary = useHasPermission("settlement.view_sale_summary");
  const monthNames = useMemo(() => getMonthNames(t), [t]);

  const columns: GridColDef[] = useMemo(() => [
    {
      field: "month",
      headerName: t("Month"),
      flex: 1,
      minWidth: 160,
      valueFormatter: (value) => {
        if (!value) return "";
        const date = dayjs(value);
        return `${monthNames[date.month() + 1]} ${date.year()}`;
      },
    },
    {
      field: "total",
      headerName: t("Value (zł)"),
      flex: 1,
      minWidth: 160,
      align: "right",
      headerAlign: "right",
      valueFormatter: (value) => formatNumber(value),
    },
  ], [t, monthNames]);

  if (!canViewSaleSummary) {
    return (
      <Alert severity="warning" sx={{ m: 2 }}>
        {t("You do not have permission to view the sale summary.")}
      </Alert>
    );
  }

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <CustomDataGrid
        url={`${SETTLEMENTS_ENDPOINT}sale-summary-statistics/`}
        gridSettingsKey="SETTLEMENTS_STATISTICS"
        columns={columns}
        initialSortModel={[{ field: "month", sort: "desc" }]}
        dataGridProps={{ autoHeight: true, pageSizeOptions: [10, 25, 50] }}
      />
    </Box>
  );
};
